const actionTypes = (base) => ({
  [`${base}_REQUEST`]: `${base}_REQUEST`,
  [`${base}_SUCCESS`]: `${base}_SUCCESS`,
  [`${base}_FAILURE`]: `${base}_FAILURE`,
});

export const reportingConstants = {
  ...actionTypes("GET_REPORTING_WIDGETS"),
  ...actionTypes("CREATE_REPORTING_WIDGET"),
  ...actionTypes("UPDATE_REPORTING_WIDGET"),
  ...actionTypes("DELETE_REPORTING_WIDGET"),

  ...actionTypes("CREATE_REPORTING_SERIES"),
  ...actionTypes("CREATE_REPORTING_SERIES_BULK"),
  ...actionTypes("UPDATE_REPORTING_SERIES"),
  ...actionTypes("DELETE_REPORTING_SERIES"),
  ...actionTypes("REORDER_REPORTING_SERIES"),

  // Kept with their existing names (including the SUCCES typo) so other
  // places that reference them keep working.
  IS_REPORTING_INTEGRITY_INTACT_REQUEST: "IS_REPORTING_INTEGRITY_INTACT_REQUEST",
  IS_REPORTING_INTEGRITY_INTACT_SUCCES: "IS_REPORTING_INTEGRITY_INTACT_SUCCES",
  IS_REPORTING_INTEGRITY_INTACT_FAILURE: "IS_REPORTING_INTEGRITY_INTACT_FAILURE",
  SET_REPORTING_INTEGRITY_FALSE_SUCCESS: "SET_REPORTING_INTEGRITY_FALSE_SUCCESS",
  SET_REPORTING_INTEGRITY_FALSE_FAILURE: "SET_REPORTING_INTEGRITY_FALSE_FAILURE",
};